module.exports = __webpack_public_path__ + "img/client-8--small.png?08e53f6b251b862e81a367ae9098a3ad";